import { goRequest } from '../utils/httpClientTs';
import { ScheduledTask } from '../types/scheduledTasks';

/**
 * Get all scheduled tasks (admin only)
 * @returns Promise<ScheduledTask[]>
 */
export const getScheduledTasks = async (): Promise<ScheduledTask[]> => {
  return goRequest<ScheduledTask[]>({
    url: '/api/admin/scheduled-tasks',
    method: 'GET',
  });
};

export interface QueueFundStatementJobsResponse {
  queued: string[];
  as_of_date?: string;
}

/**
 * Queue fund_mip_totals then fund_transfer_allocations orchestrators (admin only).
 * Omit asOfDate to process all MIP years.
 */
export const queueFundStatementJobs = async (
  asOfDate?: string
): Promise<QueueFundStatementJobsResponse> => {
  const body =
    asOfDate && asOfDate.trim() !== '' ? { as_of_date: asOfDate.trim() } : {};
  return goRequest<QueueFundStatementJobsResponse>({
    url: '/api/admin/scheduled-tasks/fund-statement-jobs',
    method: 'POST',
    data: body,
  });
};

export interface QueueBackfillUserImisIDsResponse {
  queued: string;
}

/**
 * Queue backfill_user_imis_ids to assign Member IDs for users missing imis_id.
 */
export const queueBackfillUserImisIDs =
  async (): Promise<QueueBackfillUserImisIDsResponse> => {
    return goRequest<QueueBackfillUserImisIDsResponse>({
      url: '/api/admin/scheduled-tasks/backfill-user-imis-ids',
      method: 'POST',
      data: {},
    });
  };

export interface QueueBackfillAddressGeocodesResponse {
  queued: string[];
}

/**
 * Queue member-address and chapter geocode backfills.
 */
export const queueBackfillAddressGeocodes =
  async (): Promise<QueueBackfillAddressGeocodesResponse> => {
    return goRequest<QueueBackfillAddressGeocodesResponse>({
      url: '/api/admin/scheduled-tasks/backfill-address-geocodes',
      method: 'POST',
      data: {},
    });
  };
